export default {
	currencies: {
		USD: "USD",
		UZS: "UZS",
		EUR: "EUR",
		GBP: "GBP",
		RUB: "RUB",
		CHF: "CHF"
	},
	langs: {
		ru: {
			title: "Русский",
			flag: "ru"
		},
		en: {
			title: "English",
			flag: "us"
		},
		uz: {
			title: "Ўзбекча",
			flag: "uz"
		}
	},
	fileExtensions: {
		PDF: "PDF",
		XLS: "XLS",
		DOC: "DOC",
		TXT: "TXT"
	},
	errors: {
		error: "Уланиш хатоси",
		errorTitle: "Хато",
		noMatches: 'Ўхшашлик топилмади'
	},
	login: {
		viaDigitalSign: {
			comeBack: 'Ортга қайтиш',
			enterPassword: 'ЭРИ сертификатининг паролини киритинг',
			selectCompany: 'Ташкилотни танланг',
			notConnected: 'ЭРИ ТБМ модули уланмаган',
			setupModule: 'Ташкилотни қўшиш учун модулни ўрнатиш керак',
			setup: 'Ўрнатиш',
			becomeClient: 'Банк мижозига айланиш',
			insertKey: 'ЭРИ калитини киритинг',
			keyNotFound: 'ЭРИ калити топилмади. ЭРИ калитини УСБ-портга жойлаштиринг. Агар сизда ЭРИ калити бўлмаса, уни олиш учун Банкнинг энг яқин филиалига мурожаат қилинг.',
			keyTerm: 'ЭРИ нинг амал қилиш муддати',
			left: 'қолди',
			enterSmsCode: 'СМС орқали келган кодни киритинг',
			sessionFinished: 'Сессия тугади',
			sessionExpiredDetails: 'Сиз {0} дақиқа давомида фаоллик кўрсатмадингиз, сессия хавфсизлик мақсадида узиб қўйилди. Сиз қайта киришингиз мумкин',
			reSignIn: 'Бошқатдан кириш',
			backToCompanyList: 'Ташкилотлар рўйхатига қайтиш',
			yourAccount: 'Сизнинг ҳисоб қайдномангизга ',
			quickAccess: 'Тез кириш созламалари',
			enableSms: 'Киришни тасдиқлаш учун СМС кодни ёқиш',
			disableSms: 'Киришни тасдиқлаш учун СМС кодни ўчириш',
			confirmationSms: 'Киришни тасдиқлаш учун СМС коди',
			smsDisablingDetails: 'Функция ўчирилган бўлса, киришни бир марталик СМС-код билан тасдиқлаш шарт эмас',
			day: 'кун',
			days: 'кун',
			moreDays: 'кун',
			selectOS: 'Операцион тизимни танланг',
			setupModuleOS: 'Компьютерингизга УЦ ЭЦП модулини ўрнатинг',
			WINDOWS: 'Windows',
			MAC_OS: 'macOS',
			selectKeyType: 'Калит турини танланг',
			howSetup: 'Қандай ўрнатиш',
			becomeClientInfin: 'InfinBusiness мижози бўлинг',
			growBusiness: 'Биз билан бизнесингизни ривожлантиринг',
			becomeCustomer: 'Мижоз бўлиш',
			I_KEY: 'iKey',
			E_PASS: 'ePass',
			setupToComputer: 'Модулни қандай ўрнатиш мумкин компьютерингизга \n ЭРИ ТМ',
			setupToOSByKeyType: '{0}да ЭРИ ТМ модулини қандай ўрнатиш мумкин \n({1} калит тури)',
			downloadArchive: 'Архивни юклаб олинг',
			downloadArchiveDescription: 'Аввал я архив юклаб олишингиз керак, кейин архиватор ёрдамида архивни очишингиз керак. Архивда иккита файл мавжуд: IKEY.эхе ва Isigner.эхе.',
			setupIkeyDriver: 'Кейин IKEY драйверини ўрнатиш керак',
			setupIkeyDriverDescription: 'Компьютерингиз калитни кўра олиши учун уни ўрнатиш керак.',
			setupProcess: 'Ўрнатиш жараёни',
			setupProcessDescription: '<ul class="simple-list"><li>Ўрнатиш жараёнида сиз драйвер лицензиясини қабул қилишингиз, "Ҳа" тугмасини босишингиз керак</li><li>Шунингдек, ўрнатиш пайтида калитнинг драйверга мослигини аниқлаш учун USB портига флеш-калитни жойлаштиришни сўрайдиган модал ойна пайдо бўлади. Калит киритилгандан сўнг, дастур ўрнатишни давом эттиради.</li><li>Юклаш тугагандан сўнг, "Finish" тугмасини босинг.</li></ul>',
			execIsigner: 'Кейин Isigner ўрнатиш керак',
			execIsignerProblem: 'Кейин Isigner ўрнатиш керак',
			execIsignerProblemDescription: 'Агар сизда дастурни ўрнатиш имкони бўлмаса, у ҳолда аввал сичқончанинг ўнг тугмасини файлга босинг ва менюдан "Хусусиятлар" командасини танланг, сўнгра "Блокдан чиқариш" байроқчасини қўйинг ва скриншотда кўрсатилгандек "ОК" тугмасини босинг.<br><br>Кейин қайта ўрнатиш мумкин (агар муваффақиятсиз бўлса, файл устига сичқончанинг ўнг тугмасини босинг ва менюдан "Ишга тушириш номидан администратор") буйруғини танланг.',
			openSetuper: 'Ўрнатувчини очишда "Кейинги" тугмасини босинг',
			openSetuperDescription: 'Шунингдек, очилган ўрнатиш ойнасида дастур компьютерингизнинг иш столида жойлашишини истасангиз, байроқчани босишингиз мумкин.',
			clickToSetup: 'Кейин "Ўрнатиш" тугмасини босинг',
			clickToReady: 'Сўнгра "Тайёр" тугмасини босинг',
			clickToReadyDescription: 'Шунингдек, дастурни дарҳол ишга тушириш учун байроқчани босишингиз мумкин.',
			setupCompleted: 'Шу билан ўрнатиш жараёни якунланади',
			setupCompletedDescription: 'Агар ҳаммасини бажарган бўлсангиз бандлар, кириш экранига қайтиб, ташкилотингизга кира оласиз ташкилот',
		},
		sessionExpirationNotification: '‌{remainingTime} кейин сессияда узилиш бўлади. Сессияда узилиш бўлмаслиги учун исталган ҳаракатни бажаринг',
		confirmSmsCancellation: "Смс киритишни бекор қилмоқчимисиз?",
		resendSms: "Юборилган смс муддати тугади, авторизацияни янгилаш учун Сиз янгисини олишингиз керак",
		authorization: "Интернет-банкка кириш",
		login: "Логин",
		password: "Парол",
		error: "Мажбурий катак",
		errorPassword: "Бу кичик белги, катта ҳарфлар ва рақамни ўз ичига олиши керак.",
		loginOpen: "Кириш",
		forgetPassword: "Паролни унутдингизми?",
		howRegister: "Қандай қилиб банк мижозига айланиш мумкин?",
		banner: {
			title: `Сизнинг шахсий <br/> мобил банкингиз!`,
			text: "Барча хизматлар қўлингизда",
			btnApp: "Иловани юклаб олиш",
			btnBrowser: "Браузер орқали давом этинг",
			btnUnavailable: 'Афсуски, "Infinbusiness" нинг веб-версияси фақат компютер ёки ноутбук Браузери орқали мавжуд.',
		},
		help: {
			title: "Ҳурматли мижоз!",
			text: "Кириш учун банк филиалининг офисига мурожжат қилиш ва рўйхатдан ўтиш зарур.<br/>Рўйхатдан ўтиш учун зарур ҳужжатлар:<br/>1. Фойдаланувчининг шахсини тасдиқловчи ҳужжат;<br/>2. Мобил иловадан фойдаланиш учун ташкилотнинг ишончнома-хатининг асл нусхаси (қуйида қаранг)",
			download: "Шаклни юклаб олиш",
			close: "Тушунарли"
		},
		passwordReset: {
			title: "Ҳурматли мижоз!",
			text: "Паролни тиклаш учун банк бўлимига паспорт билан мурожаат қилиш лозим",
			close: "Тушунарли"
		},
		smsCode: {
			title: "СМС орқали <br/> келган кодни киритинг",
			repeat: "Кодни яна юбориш"
		}
	},
	headerAuth: {
		phone: "Call center бизнес учун",
		telegram: "Телеграм бот",
		department: "Бўлим"
	},
	howRegister: {
		headerTitle: "Қандай қилиб банк мижозига айланиш мумкин",
		header: "Банк мижозига айланиш мумкин",
		steps: {
			title: "Учта қадам ва сиз банк мижозига айланасиз!",
			step1: "Банк вакилининг Компания раҳбарияти билан шахсан учрашиш",
			step2: "Банк ҳисобварағини очиш учун ҳужжатларнинг тўлиқ пакетини тақдим этиш",
			step3: "Ҳисобварақ очиш"
		},
		btn: "Батафсил маълумот",
		urlBranch: "https://infinbank.com/uz/branches/",
		department: {
			title: "Банк бўлими",
			text: "Банкка маршрутини яратинг"
		},
		doc: {
			title: "Ҳужжатлар",
			text: "Бизнесни рўйхатдан ўтказиш учун зарур"
		},
		tariffs: {
			title: "Тарифлар",
			text: "Мавжуд тарифларни текширинг"
		},
		footer: {
			title: "Контактлар",
			phone: "Банк билан қуйидаги телефон орқали боғланиш мумкин",
			email: "Электрон почта орқали",
			text: "Банк мутахассиси билан бирга ҳисобварақ очиш учун филиални олдиндан келишилган вақтда ташриф буюринг."
		}
	},
	tariffs: {
		header: "Тарифлар",
		btnAllDownload: "Барча тарифларни юклаб олиш",
		btnAllView: "Барча тарифлар",
		currentTariff: "Жорий тариф:",
		description: "Пакет нархи",
		month: "ой бошига",
		cost: "Бепул",
		commission: "комиссиясиз",
		download: "Юклаб олиш",
		titleOther: "Бошқа амалдаги тарифлар",
		debit: "Дебет айланмалар",
		foreignCurrency: "Хорижий валютадаги тўловлар",
		nationalCurrency: "Миллий валютадаги амалиётлар",
		from: "дан",
		before: "олдин"
	},
	doc: {
		header: "Ҳужжатлар",
		title: "Банк ҳисобварағини очиш учун талаб этиладиган ҳужжатлар",
		btnAllDownload: "Барча ҳужжатлар юклаб олиш",
		download: "юклаб олиш"
	},
	munis: {
		insufficientFunds: "Маблағ етарли эмас",
		selectCategory: 'Тоифани танланг',
		operDayClosed: 'Амалиёт куни ёпилмоқда',
		operationsDisabled: 'Амалиётлардан вақтинчалик фойдаланиб бўлмайди',
		check: 'Текшириш',
		btnSendToBank: 'Имзолаш ва юбориш',
		alreadyPaid: 'Кўрсатилган рақам бўйича квитанциядаги сумма тўланди',
		paymentInfo: 'Тўлов тўғрисида маълумотлар',
		continue:'Давом этиш',
		searchText: 'Хизмат тоифаси ёки турининг номи',
		nothingFound: 'Ҳеч нарса топилмади',
		maxAmountError: 'Миқдори {0} UZS ошмаслиги керак'
	},
	register: {
		registryOperationsText: 'Реестр амалиётлари',
		dndFileTitle: 'Тўлдирилган реестр амалиётини танланг ёки тортиб ўтказинг',
		fileFormat: 'Файл формати excel (.xls, .xlsx)',
		selectFile: 'Файлни танлаш',
		rules: 'Қаторларни тўлдириш қоидалари',
		downloadTemplate: 'Тўлдириш учун шаклни юклаб олинг',
		excelFile: 'Excel Файл',
		operDayClosed: 'Амалиётни вақтинча бажариш мумкин эмас. Амалиёт кунини ёпиш жараёни давом этмоқда',
		formatFileError: 'Файл формати .xls, .xlsx бўлиши керак',
		creation: 'Реестр амалиётини яратиш',
		editing: 'Рўйхатга олиш амалиётини таҳрирлаш',
		uploadedFile: 'Юкланган файл',
		changeFile: 'Файлни алмаштириш',
		fileDownload: 'Файлни юклаб олиш',
		amountOfOperations: 'Тўлов топшириқномалари сониэ',
		totalAmount: 'Умумий сумма',
		debitAccount: 'Ҳисобдан чиқариш ҳисоб рақами',
		errorModalTitle: 'Реестр амалиётини юклаб бўлмади',
		errorMessageTitle: 'Қаторлар тўғри тўлдирилганлигини текширинг:',
		errorCheckTableLines: 'Жадвал тўғри тўлдирилганлигини текширинг.',
		helpText: '',
		helpLink: 'Қаторларни тўлдириш қоидаларини кўриб чиқишни тавсия қиламиз',
		selectAccount: 'Ҳисобдан чиқариш ҳисоб рақамини танланг',
		btnEnter: 'Киритиш',
		btnApprove: 'Директорга юборинг',
		btnSendToBank: 'Имзолаш ва юбориш',
		fileChanged: 'Файл алмаштирилди',
		registerPayment: 'та тўлов топшириқномаси',
		registerPayments: 'та тўлов топшириқномаси',
		twoRegisterPayments: 'та тўлов топшириқномаси',
		downloadFile: 'Файлни юклаб олиш',
		operationStatus: 'Амалиёт мақоми',
		reasonPaymentRefund: 'Тўлов қайтарилишининг сабаби:',
		contactOurSupportTeam: 'Агар саволларингиз бўлса ёки қўшимча маълумот керак бўлса, қўллаб-қувватлаш хизматига мурожаат қилинг.',
	},
	home: {
		questionnaire: "Сўровнома №",
		createTitlePayment: "Тўлов буюртномасини яратинг",
		createNewTitlePayment: "Айнан бир хил тўлов топшириқномасини яратиш",
		addFavoriteBills: "Бош саҳифага қўшиш",
		company: "МЧЖ",
		titleBills: "Компания ҳисобварағи",
		textBills: "Барчасини кўрсатиш",
		nameAccount: "Транзит ҳисобварақ",
		notification: {
			title: "Хабарнома",
			text: "Сизга хабарнома келди, илтимос, матнни ўкиш учун босинг",
			emptyText: "Сизда ҳеч қандай билдиришнома йўқ",
			openText: "Хабарномани очиш"
		},
		tabsList: {
			titlePayment: "Тўлов топшириқномаси",
			recent: "Охиргилар",
			templates: "Шаблонлар",
			btnRecent: "Кўпроқ кўрсатиш"
		},
		statusPayment: {
			title: "Тўлов топшириқномаларнинг ҳолатлари",
			inbox: "Кирувчи",
			outgoing: "Чиқувчи тўловлар ва аризалар",
			approval: "Тасдиқловда",
			revision: "Қайта кўриб чиқишга юборилганлар",
			draft: "Қораламалар"
		},
		offers: "Сиз учун таклифлар",
		payment: {
			title1: "Тўлов топшириқномаси",
			title2: "Анор",
			title3: "Бюджетга топшириқнома",
			title4: "Пластик картани тўлдириш",
			title5: "Ғазначиликка топшириқнома",
			title6: "Иш ҳақи қайдномаси",
			munis: 'МУНИС',
			register: 'Реестр амалиёти',
			loanRepayment: 'Кредитни тўлаш',
			anor: 'АНОР'
		},
		organization: "Ташкилотни танлаш",
		branch: "Филиални танланг",
		favoriteBills: {
			header: "Сараланган ҳисобварақлар",
			block1: "Танланди",
			block2: "Бошқалар",
			titleBlockSelect: 'Сараланган'
		},
		modalPassword: {
			text: "Ҳурматли мижоз! Паролингиз муддати (5/4/3/2/4 кундан) кейин тугайди. Хавфсизлик ва ҳисоб қайдномасингизга рухсатсиз киришни олдини олиш  мақсадида жорий паролингизни ўзгартиришингизни сўраймиз.",
			textChange: "Хавфсизлик ва ҳисоб қайдномасингизга рухсатсиз киришни олдини олиш  мақсадида паролингиз муддати тугаган. Сиздан жорий паролингизни ўзгартиришингизни сўраймиз.",
			btnChange: "Ҳозир ўзгартириш",
			btnLater: "Кейинроқ ўзгартириш"
		}
	},
	header: {
		main: "Бош саҳифаси",
		services: "Хизматлар",
		chat: "Чат",
		history: "Тарихи",
		electCommerce: "Електрон тижорат",
		mfo: "Mфo:",
		in: "в"
	},
	menu: {
		closedOperDay: "Операцион кун ёпиқ",
		operDay: "Операцион кун:",
		terms: "Тариф",
		employees: "Ходимлар",
		setting: "Созламалар",
		branch: "Филиаллар",
		current: "Валюта курслари",
		contract: "Контрагентлар",
		support: "Қўллаб-қувватлаш",
		signOut: "Аккаунтдан чиқиш",
		appVersion: "Версия"
	},
	breadcrumb: {
		title: "Бош саҳифаси"
	},
	companyAccounts: {
		cards: {
			title: "Карталар",
			btn: "Заказать карту",
			info: {
				title: "Карта тўғрисида маълумот",
				number: "Карта рақами",
				balanceCards: "Картадаги қолдиқ",
				nameCard: "Дебит картаси",
				tabInfo: "Карта тўғрисида"
			},
			statuses: {
				active: "Карта фаол",
				lock: "Карта блоклаган",
				blockClient: "Мижоз томонидан блокланган",
				pinLimit: "PIN код талаб қилинади",
				pin: "PIN кодни киритиш чегарасига етди",
				blockBank: "Банк томонидан блокланган"
			},
			history: {
				btnFirst: 'Тушум',
				btnSecond: 'Чиким',
				print: 'Чоп этиш',
				translate: 'Ўтказилди',
				point: 'Тўлов пункти',
				servicePoint: 'Хизмат кўрсатиш пункти',
				terminal: 'Терминал',
				date: 'Тўлов санаси ва вақти',
				amountCancel: 'Ечиладиган сумма',
				numberTransaction: 'Транзакция рақами'
			}
		},
		deposits: {
			title: "Депозитлар",
			info: {
				title: "Омонат ҳақида маълумот"
			},
			titleByType: {
				SAVINGS_DEPOSIT: 'Жамғарма депозит',
				TERM_DEPOSIT: 'Муддатли депозит',
			}
		},
		bills: {
			cardBlocked: "Ҳисоб блокланди",
			blocked: "Блокланган",
			title: "Ҳисобварақлар",
			info: {
				title: "Ҳисобварақ ҳақида маълумот",
				number: "Ҳисобварақ рақами",
				mfo: "МФО",
				date: "Очилган санаси",
				dateClose: "Ёпилиш санаси",
				status: "Ҳолати",
				openBal: "Кирим қолдиғи",
				debit: "Дебит",
				credit: "Кредит",
				closBal: "Чиқим қолдиғи",
				history: "Тарихи",
				approved: "Тасдиқланган",
				opened: "Очилган",
				closed: "Ёпилган",
				balanceAccount: "Ҳисоб-рақамдаги қолдиқ",
				tabInfo: "Ҳисоб-рақам тўғрисида"
			}
		},
		loans: {
			title: "Кредитлар",
			header: "Кредит суммаси",
			remaining: "Қолди",
			payment: "та тўлов",
			titleMain: "Асосий сумма:",
			titleAccrued: "Ҳисобланган %:",
			noPaid: "Тўланмаган",
			paid: "Тўланган",
			creditPurpose: "Кредит мақсади",
			loanAccounts: "Ссуда ҳисоб рақами",
			nextPay: "Кейинги тўлов:",
			overduePay: "Кечиккан тўлов:",
			repay: "Сўндириш",
			schedule: "График",
			creditDetails: "Кредит бўйича тафсилотлар",
			principalDebt: "Асосий қарз қолдиғи",
			accrued: "Ҳисобланган фоизлар",
			totalCredit: "Кредитнинг жами суммаси",
			contractTerms: "Шартнома шартлари",
			contractNumber: "Шартнома рақами",
			contractDate: "Шартнома санаси",
			interestRate: "Фоиз ставкаси",
			contractEffect: "Шартноманинг амал қилиш муддати:",
			loanAccount: "Ссуда ҳисобварағи рақами",
			nextPayment: "Кейинги тўлов",
			tabInfo: "Кредит ҳақида",
			minAmount: 'Тақдим этиладиган кредитнинг минимал суммаси (лимит) {0} UZS',
			maxAmount: 'Тақдим этиладиган кредитнинг максимал суммаси (лимит) {0} UZS',
			history: {
				btnFirst: 'Тўлов',
				btnSecond: 'Кредит бериш',
				title: 'Кредитнинг фойдаланиш тарихи',
				emptyBlock: {
					title: 'Танлаган давр учун операция мавжуд эмас',
					text: 'Операцияни кўрсатиш учун даврини ўзгартиринг'
				}
			}
		},
		replenish: {
			header: "Тўлдириш",
			title1: "Қаердан",
			title2: "Қаерга",
			inputLabel: "Ўтказма суммаси",
			inputText: "Комиссия:",
			card: 'Картани тўлдириш'
		},
		transfer: "Ўтказиш",
		modal: {
			titleUnlockCard: "Картани блокдан чиқариш",
			textUnlockCard: "Картани блокдан чиқариш хохлайсизми?",
			titleLockCard: "Картани блоклаш",
			textLockCard: "Картани блокировка қилиш хохлайсизми?"
		},
		cancel: "Бекор қилиш",
		accept: "Қабул қилиш",
		nameAccount: "Ҳисобварақ номи"
	},
	createSumPayment: {
		loanRepaymentDetail: 'Кредитни тўлаш буйича сўровнома № {0}',
		nameBank: "Банк номи",
		header: "Янги тўлов",
		treasuryMinitstry: 'Казначейство Министерства финансов Республики Узбекистан',
		aside: {
			title: "Ҳисоб-рақам тўғрисида маълумот",
			textField1: "Топшириқнома тури",
			textField2: "Ҳужжат рақами",
			textField3: "Тўлов санаси",
			btn: "Шаблонлардан танланг"
		},
		send: {
			title: "Пул юборувчи",
			textField1: "Жўнатувчининг номи",
			receiverName: "Олувчининг номи",
			textField2: "Тўловчининг ҳисобварақ рақами",
			senderAccount: "Олувчининг хисоб рақами",
			textField3: "Тўловчининг МФО",
			receiverMFO: "Олувчининг \"МФО\"си",
			textField4: "Тўловчининг СТИР",
			receiverINN: "Олувчининг \"СТИР\" рақами",
			checkboxesTitle: "АНОР орқали ўтказиш",
			checkboxesText: "Марказий банкнинг ҳисоб-китоб маркази одатда иш кунлари соат 17:00 гача ишлайди. Соат 17:00 дан кейин АНОР орқали ўтказмалардан фойдаланишни тавсия етамиз. АНОР орқали ўтказмалар учун Банк тарифларига мувофиқ қўшимча комиссия олинади",
			checkboxesTextDisabled: "АНОР орқали пул ўтказиш фақат банклараро ўтказмалар учун амал қилади"
		},
		recipient: {
			title: "Пул олувчи",
			textField1: "Пул олувчининг номи",
			clientName: "Мижоз номи",
			textField2: "Пул олувчининг ҳисобварақ рақами",
			textField3: "СТИР",
			textField4: "Олувчининг шахсий хисобварағ рақами",
			type: "Олувчининг турини танланг",
			corpCard: "Корпоратив карта",
			dividends: "Дивидендлар",
			other: "Бошқалар",
			cardNotFound: "Харита топилмади",
			innField: 'Қабул қилувчининг СТИР рақамини киритинг',
			cardPhisFaces: 'Жисмоний шахс картаси',
			defaultText: 'Корпоратив карта тўлдирилиши'
		},
		other: {
			textField1: "Ҳужжат суммаси",
			textField2: "Тегишли код",
			textField3: "Тўлов мақсади",
			textField4: "Шахсий ҳисобварақ",
			textField4LabelDialog: "Ташкилотнинг шахсий хисобварағини қидириш"
		},
		btn: {
			first: "Имзолаш ва жўнатиш",
			first2: "Киритинг",
			first3: "Тасдиқлайман",
			first4: "Тасдиқлайман ва жўнатиш",
			second: "Қораламани сақлаш",
			third: "Шаблонни сақлаш",
			reject: "Рад этиш"
		},
		payment: {
			title1: "Жисмоний шахс",
			title2: "Импорт",
			title3: "Займни қайтариш",
			title4: "Дивидендлар",
			title5: "RUz худудида",
			title6: "Бошқалар",
			title7: "Экспортни қайтариш",
			title8: "Ўз маблағларни ўтказиш"
		},
		errorMessage: "Сиз бошқа юридик шахсга ёки якка тартибдаги тадбиркорга тегишли корпоратив карталарни тўлдира олмайсиз",
		paymentAmount: "Тўлов суммаси",
		bankCommission: "Банк комиссияси",
		additionalPay: "Тўловнинг қўшимча маълумотлари ",
		dialogSuccess: {
			title: "Қайта ишлашга банкка юборилди",
			user: "Сизнинг {2}й.даги {0} {1} тўловингиз бухгалтерга муваффақиятли юборилди.",
			bux: "Сизнинг {2}й.даги {0} {1} тўловингиз раҳбарга муваффақиятли юборилди.",
			director: "Имзоланган",
			templates: "Шаблонларга сақланган",
			recipient: 'Илтимос, тўлов холатини билдиришнома еки "Тарих" бўлимида кузатиб боринг"',
			recipient3: 'Тўлов холатини билдиришнома еки "Тарих" бўлимида кузатиб боринг"',
			checkStatusLater: "Тўлов қайта ишланмоқда. Илтимос, статусни кейинроқ текширинг",
			recipientAnor: 'Анор орқали ўтган тўловлар Банк томонидан 10 минут давомида қайта ишланади. Тўловнинг қайта ишлаш натижаси "Тарих" бўлимида акс этади',
			drafts: "Қораламаларга сақланган",
			successfullySent: "Муваффақиятли юборилди",
			payrollBux: 'Сизнинг {2}й.даги {0} {1} иш ҳақи қайдномангиз раҳбарга муваффақиятли юборилди.',
			payrollEmployee: 'Сизнинг {2}й.даги {0} {1} иш ҳақи қайдномангиз бухгалтерга муваффақиятли юборилди.',
			btn: 'Ок',
			subTitle: "Банкка юборилди",
			recipient2: "Агар амалиёт ёпиқ амалиёт кунига тўғри келса, у кейинги иш кунида қайта ишланади. Амалиёт қачон амалга оширилиши ҳақида сизни хабардор қиламиз."
		},
		dialogSuccessTitle: 'Тўлов топшириқмаси банкка мувоф',
		dialogErrorTitle: 'Амалиётни бажаришда хатолик юз берди',
		dialogPendingTitle: 'Тўлов топшириқномаси кутиш режимида',
		cardAccount: "Карта ҳисоб-рақами",
		cardAccountReceiver: 'Олувчининг карта хисоб рақами',
		transitAccount: "Транзит ҳисоб-рақами",
		numbers: "coн",
		isAnorInfoText: "Анор орқали тўловни амалга ошириш учун тўловни ўзгартириш ва олувчининг СТИР ни кўрсатиш лозим",
		cardErrorMessage: 'Карта фаол эмас ёки бундак рақамли карта мавжуд эмас. Карта рақами тўғри киритилганлигини текшириб кўринг',
		cardNotSupported: 'Ушбу турдаги карталар мавжуд емас',
		error: {
			corpCard: 'Сиз корпоратив карта рақамини киритдингиз. Уни тўлдиришни хохлайсизми?',
			individualCard: 'Сиз жисмоний шахс карта рақамини киритдингиз. Уни тўлдиришни хохлайсизми?',
			numberAccountRecipient: 'Жўнатувчи ва олувчининг хисоб рақами бир мижозга тегишли эмас',
			validSymbols: `Қатор лотин ҳарфлари ва / - ? : ( ) . , ' + белгиларини ўз ичига олиши мумкин`
		}
	},
	employees: {
		positionEmplyee: "Раҳбар",
		btnFirst: "Ваколат роллари билан танишиш",
		btnSecond: "Ўчириш",
		btnThird: "Блоклаш",
		btnFourth: "Блокдан чиқариш",
		modalLock: {
			title: "Ходимни блокировка қилиш",
			text: "Ходимни вақтинча блокировка қилишга ишончингиз комилми?"
		},
		modalUnLock: {
			title: "Ходимни блокдан чиқариш",
			text: "Ходимни блокдан чиқариш хохлайсизми?"
		},
		modalDelete: {
			title: "Ходимни ўчириш",
			text: "Ходим профили ўчирилишини хохлайсизми?",
			btnCancel: "Бекор қилиш",
			btnClose: "Ёпиш"
		},
		assignRole: {
			text: "Шартномани имзолаш ва туловларни юбориш, рол модели ва карталарни бошқаришдан ташқари барча функциялардан фойдаланиш мумкин.",
			btnText: "Ваколатлар бўлими ҳақида батафсил ",
			authority: "Ваколатлар",
			btnComplete: "Ролни тайинлаш"
		},
		authority: {
			makingPayment: "Тўловларни ўтказиш",
			saveDraft: "Қораламани сақлаш",
			view: "Кўриб чиқиш",
			getExtract: "Кўчирма олиш",
			createVP: "Харид қайдномаси яратиш",
			downloadStatement: "Қайдномани юклаш",
			saveStatement: "Қайдномани сақлаш (Шаблон)",
			viewRole: "Рол/ваколатни қўриб чиқиш",
			lock: "Блоклаш/блокдан очиш",
			delete: "Ўчириш",
			sendEmployee: "Киритиш (ЭРИсиз)",
			sendAccountant: "Киритиш ва тасдиқлаш (ЭРИсиз)",
			sendDirector: "Киритиш ва юбориш (ЭРИ зарур)",
			sendAccountantPayroll: 'Тасдиқлаш (ЭРИсиз)',
			paymentVisibility: "Тўловларнинг кўриниши"
		}
	},
	currentDate: "Бугун",
	drafts: {
		header: "Қораламалар",
		deleteDrafts: "Қораламаларни ўчириш",
		deleteDraft: "Қораламани ўчириш",
	},
	electCommerce: {
		header: "Электрон тижорат",
		checkNumber: "Чек рақами",
		approved: "Бажарилган",
		declined: "Рад қилинган",
		paymentDate: "Тўлов санаси ва вақти:",
		paymentPoint: "Тўлов нуқтаси",
		paymentSender: "Тўлов юборувчиси",
		paymentName: "Тўлов номи",
		senderCardNumber: "Пул юборувчининг карта рақами",
		comment: "Тўлов мақсади",
		payDate: "Тўлов санаси",
		name: "Номи",
		serviceId: 'Хизмат идентификатори',
		categoryId: 'Хизмат тоифаси идентификатори',
		serviceName: 'Хизмат номи',
		payTime: 'Тўлов амалга оширилган вақт',
		subscriber: 'Обуначи',
		amount: 'Ўтказма миқдори',
		commission: 'Воситачилик ҳақи',
		systemCommission: 'Тизим воситачилик ҳақи',
	},
	nameTemplate: "Шаблонга ном беринг",
	savedInTemplates: "Шаблонларга сақланган",
	payroll: {
		createNewTitle: 'Ведомостни яратинг, юкланг ёки андазани юклаб олинг',
		title: "Иш ҳақи учун тўлов тизимини танланг",
		titleMin: "Тўлов тизимини танланг",
		text: "Иш ҳақи тўловини расмийлаштириш учун ходимни рўйхатга қўшинг ва суммани киритинг. Ёки қайдномани юкланг.",
		btnSelect: "Пул олувчини танлаш",
		btnAdd: "Қайднома қўшиш",
		totalSum: "Жами сумма",
		paymentRecipient: "Тўлов олувчилар",
		employee: "та ходим",
		employee1: "та ходим",
		employee2: "та ходим",
		btnAddEmployee: "Ходим қўшиш",
		btnDeleteEmployee: "Ходимни ўчириш",
		btnDeleteEmployeeText: "Ходимни қайдномадан ўчирмоқчимисиз?",
		btnSend: "Банкка юбориш",
		btnUzcard: "Тўлов UZCARD орқали",
		btnHumo: "Тўлов HUMO орқали",
		createNewPayroll: {
			title: "Иш ҳақи қайдномасини яратиш",
			text: "Рўйхатдаги ходимларни танланг ва ҳар бири учун иш ҳақини кўрсатинг"
		},
		downloadPayroll: {
			title: "Иш ҳақи қайдномаси",
			blueText: "Танланг",
			text: " еки Ҳажми 20 МБ гача бўлган xls, xlsx файлни тортиб олинг.",
			textUpdate: 'Файлни шу ерга ўтказинг',
			textUpdate2: 'Ўлчами 20 Мб гача бўлган xls, xlsx файллари',
		},
		addTemplate: {
			title: "Шаблондан қўшиш",
			text: "Олдиндан сақланган шаблонлардан керакли шаблонни танланг"
		},
		createDownloadTemplate: {
			title: "Иш ҳақи қайдномасининг шаблонини юклаб олиш",
			text: "Сизнинг қораламаларингиздан қайднома тузамиз"
		},
		newPayroll: {
			yearOfLoading: 'Юкланган йил',
			textAll: 'Барча',
			employees: 'Ходимлар',
			swiftBankCode: 'Банкнинг SWIFT коди',
			withdrawalAccountNumber: 'Ҳисобдан чиқариш ҳисобварағининг рақами',
			enrollmentАccountNumber: 'Ҳисобга пул ўтказиш ҳисобварағи рақами',
			applicationNumber: 'Ариза рақами',
			currency: "Валюта",
			resetFilter: 'Фильтрни бекор қилиш',
			paymentDetails: 'Тўлов мақсади',
			docDate: 'Ҳужжат санаси',
			docNumber: "Ҳужжат рақами",
			sheetID: "Қайднома идентификатори",
			transitPayrollAccount: "Иш хақига оид транзит хисобварақ",
			withdrawalAccount: "Пул йечиладиган хисоб варақ",
			header: "Янги баёнот яратиш",
			title: "Пул олувчини ўзгартириш",
			name: "Пул олувчининг тўлиқ исми",
			nameUser: "Ходим ФИШ",
			score: "Пул олувчининг ҳисобварағи",
			scoreStatement: "Пул олувчининг ҳисобварағи",
			embossedName: "Пул олувчининг зарбланган исми",
			pay: "Тўловга",
			select: "Маълумотномадан танлаш",
			btnDownload: "Қайдномани юклаб олиш",
			requestDelete: "Иш ҳақи ведомостини яратишдан чиқиш",
			textDelete: "Агар иш ҳақи ведомостини яратишдан чиқсангиз, барча ўзгартишлар ўчиб кетади",
			goOut: "Чиқиш",
			stay: "Қолиш",
			sendToBank: "Банкка юбориш",
			saveTemplates: "Шаблонларни сақлаш",
			numberStatement: "Қайдномани №",
			status: "Ҳолат",
			dateDownload: "Юклаб олиш санаси",
			purposePay: "Тўлов мақсади",
			exportStatement: "Қайдномани экспорт қилиш",
			amountPaid: "Тўланадиган миқдор",
			amountSelect: "Танланган олувчиларни миқдори",
			paymentSystem: "Тўлов тизими",
			noSelect: "Танланмаган",
			searchFamilyAndAccount: 'Ходим ФИШ ёки ҳисоб рақами',
			btnScroll: 'Расмийлаштиришга ўтиш',
			copied: 'Нусха олинди',
			notCopied: 'Нусха олинмади',
			withdrawCheckBox: 'Чек-боксни олиб ташлаш учун суммани олиб ташланг',
		},
		modalAttention: {
			error: "Хатолик",
			title: "Энди сизда хомаки иш ҳақи ведомости бор",
			text: "Агар сиз юклаб олишни давом эттирсангиз, хомаки маълумотлар йўқ бўлиб кетади.",
			btnUpdate: "Хомаки вариантга ўтиш",
			btn: "Давом этиш"
		}
	},
	search: "Қидириш",
	currencyRates: {
		header: "Валюта курслари",
		tabsList: {
			first: "МБ",
			second: "ЎзРВБ курси",
			third: "Айирбошлаш шохобчаси"
		},
		currency: "Валюта",
		course: "Курс",
		buy: "Харид",
		sell: "Сотиш",
		change: "Ўзгариш",
		listCurrency: {
			USD: "АҚШ доллари",
			UZS: "Сум",
			EUR: "Евро",
			GBP: "Фунт стерлинг",
			RUB: "Россия рубли",
			JPY: "Ийена",
			QAR: "Қатар риали",
			KGS: "Қиргизистон соми",
			IRR: "Эрон риали",
			CHF: "Швейцария франки",
			UAH: "Гривна",
			TMT: "Янги туркман манати",
			TRY: "Турк лираси",
			TJS: "Тожикистон сомониси",
			THB: "Бат",
			SGD: "Сингапур доллари",
			XDR: "СДР",
			SAR: "Саудия Арабистони риали",
			PKR: "Покистон рупияси",
			AZN: "Озарбайжон манати",
			MNT: "Монголия тугpики",
			MYR: "Малайзия ринггити",
			KRW: "Корея Республикаси вони",
			CAD: "Канада доллари",
			ILS: "Янги Исроил шекели",
			IDR: "Рупия",
			GEL: "Грузия лариси",
			VND: "Донг",
			BND: "Бруней доллари",
			BRL: "Бразилия реали",
			BYN: "Белорус рубли",
			BHD: "Баҳрайн динори",
			AED: "БАА дирҳами",
			AFN: "Афғонистон афғониси",
			AMD: "Арман драми",
			AUD: "Австралия доллари",
			CNY: "Юан",
			KWD: "Қувайт динори",
			KZT: "Қозоғистон тенгеси",
			INR: "Ҳиндистон рупияси",
			HKD: "Гонгконг доллари",
			MMK: "MMK",
			KHR: "KHR",
			CUP: "CUP",
			CZK: "CZK",
			DKK: "DKK",
			HUF: "HUF",
			ISK: "ISK",
			IQD: "IQD",
			JOD: "JOD",
			LAK: "LAK",
			LBP: "LBP",
			LYD: "LYD",
			MXN: "MXN",
			MDL: "MDL",
			MAD: "MAD",
			OMR: "OMR",
			NZD: "NZD",
			NOK: "NOK",
			PHP: "PHP",
			ZAF: "ZAF",
			SEK: "SEK",
			SYP: "SYP",
			TND: "TND",
			EGP: "EGP",
			UYU: "UYU",
			YER: "YER",
			VEF: "VEF",
			SDG: "SDG",
			RSD: "RSD",
			RON: "RON",
			BYR: "BYR",
			BGN: "BGN",
			PLN: "PLN",
			DZD: "DZD",
			ARS: "ARS",
			BDT: "BDT"
		}
	},
	transfersВyАccountNumber: {
		title: "Ҳисоб рақам бўйича ўтказмалар",
	},
	payrollTab: {
		title: "Иш ҳақи ведомостлари",
	},
	swiftTransfers: {
		title: "SWIFT-ўтказмалар",
	},
	currencyOperations: {
		title: 'Валюта амалиётлари',
	},
	counterparties: {
		positionCounter: "Хорижий",
		btnAdd: "Тўлов яратиш",
		btnHistory: "Амалиётлар тарихи",
		btnChange: "Ўзгартириш",
		title: "Реквизитлар",
		name: "Контрагентнинг расмий номи",
		typeActive: "Фаолият тури",
		country: "Мамлакат",
		titleCall: "Алоқа маълумотлари",
		number: "Алоқа учун телефон рақами",
		email: "Электрон почта",
		internal: "Ички",
		foreign: "Хорижий",
		addCounterparties: {
			header: "Янги контрагент",
			type: "Контрагент тури",
			internal: "Ички",
			foreign: "Хорижий",
			name: "Контрагент номи",
			bank: "Банк",
			swift: "SWIFT - код",
			swiftBank: "Воситачи банк SWIFT - коди",
			recipientSwiftBank: "SWIFT - ҳамкор банк коди",
			additionalInfo: "Қўшимча маълумот",
			counterContract: "Контрагент мамлакати",
			save: "Контрагентни сақлаш",
			inn: "Ҳамкорнинг СТИРи",
			mfoBank: "Ҳамкор банкнинг МФО",
			nameText: "Номи",
			modal: {
				title: "Бекор қилиш",
				textCreate: "Ҳамкорни яратишни бекор қилиш хохлайсизми?",
				textEdit: "Ҳамкор ўзгаришини бекор қилиш хохлайсизми?",
				textPayment: "Тўловни бекор қилиш хохлайсизми?",
				complete: "Ҳа",
				not: 'Йўқ'
			}
		},
		modalDelete: {
			title: "Ҳамкорни ўчириш",
			text: "Ҳамкорни ўчириб ташлаш хохлайсизми?"
		}
	},
	cardIndex: {
		header: "Картотека",
		docNumber: "Ҳужжат рақами",
		organDebt: "Қарзни кўйган ташкилот",
		remainingSum: "Қолдиқ сумма",
		initSum: "Бошланғич сумма",
		totalDebt: "Қарздорликнинг умумий миқдори:"
	},
	sendingSwift: {
		header: "SWIFT юбориш",
		typeTransaction: "Амалиёт тури",
		typeMessage: "Хабар тури",
		senderBank: "Пул юборувчининг банки",
		senderCountry: "Пул юборувчи мамлакати",
		selectBox: "Катакни танланг А/D",
		accountBank: "Воситачи банкидаги ҳисобварақ",
		beneficiaryBank: "Пул олувчининг банки",
		beneficiaryBankName: "Олувчининг банк номи",
		senderBankName: "Жўнатувчининг банк номи",
		beneficiaryCountry: "Пул олувчи банк мамлакати",
		beneficiaryBikBank: "Пул олувчи банка оид БИК",
		beneficiaryKorAccountBank: "РФ Марказий банкидаги корреспондент ҳисобварақ",
		interBank: "Воситачи банки",
		interBankName: "Воситачи банк номи",
		interBankCountry: "Воситачи банк мамлакати",
		interBikBank: "Воситачи банка оид БИК",
		interKorAccountBank: "Россия Федерацияси Марказий банкида воситачи ҳисоб-рақам",
		interInn: "Пул олувчига оид СТИР",
		clientINN: "Жўнатувчининг \"СТИР\" рақами",
		interKpp: "Пул олувчига тегишли КПП",
		interMfo: "Жўнатувчининг \"МФО\"си",
		codeOperation: "Амалиёт коди",
		nameOperation: "Наименование операции",
		selectOptions: "Вариантларни танлаш",
		idn: "Шартноманинг ИД рақами",
		address: "Манзил",
		city: "Шаҳар",
		msg: "Тўлов мақсадининг номи (товар ёки хизматлар), шартноманинг рақами ва санасини кўрсатинг. Aгар матн сиғмаса, Сиз “Қўшимча тўлов маълумотлари” майдонига ўтишингиз мумкин.",
		nds: "ҚҚС билан",
		dontNds: "ҚҚС дан ташқари",
		field: "Катак",
		number: "Рақам",
		typeContract: "Шартнома тури",
		notFoundReferenceBook: "Каталогда ҳеч қандай код топилмади",
	},
	reports: {
		header: "Ҳисоботлар",
		reportType: "Ҳисоботлар тури",
		date: "Сана",
		sort: "Саралаш",
		btnReset: "Аслига қайтариш",
		terminalNumbers: "Терминал рақамлари",
		paymentSystem: "Тўлов тизимини танланг",
		selectByTerminal: "Терминал бўйича танлаш",
		selectByAllTerminals: "Барча терминаллар бўйича танлаш",
		selectBySpecificTerminal: "Махсус терминал бўйича танлаш",
		terminalReports: "Терминаллар бўйича ҳисоботлар (xlsx)",
		paymentSystemErrorText: "Кечирасиз, сизда терминаллар топилмади",
		type: {
			text1: "Қуйидаги сана учун ҳисобварақ бўйича кўчирма (excel)",
			text2: "Қуйидаги сана учун Тўлов ҳужжатлари (excel)",
			text3: "Қуйидаги давр учун ҳисобварақ бўйича кўчирма (excel)",
			text4: "Қуйидаги давр учун ўтказилган ҳужжатлар қайдномаси (excel)",
			text5: "Қуйидаги давр учун ҳисобварақ айланма ҳақида маълумотнома (excel)",
			text6: "Қуйидаги давр учун сальдо-айланма қайдномаси (excel)",
			text7: "Қуйидаги сана учун картотека қайдномаси (excel)",
			text8: "Қуйидаги давр учун шахсий ҳисобварақ кўчирмаси (excel)",
			text9: "Қуйидаги давр учун шахсий ҳисобварақ кўчирмаси, кенгайган (excel)"
		},
		sorts: {
			number: "Рақам бўйича хужжат",
			credit: "Кредит айланмаси  бўйича",
			debit: "Дебит айланмаси  бўйича"
		},
		turnovers: {
			title: 'Айланмалар',
			all: 'Барча',
			debit: 'Дебет',
			credit: 'Кредит'
		}
	},
	selectAll: "Барчасини танлаш",
	transactHistory: {
		header: "Кўчирма",
		format: "Файл формати",
		period: "Давр",
		selectPeriod: "Даврни танлаш",
		upload: "Юклаш",
		outbox: "Чиким",
		filters: "Фильтрлар",
		account: "Ҳисобварақ",
		selectAccount: "Ҳисобварақни танланг",
		year: "Йил",
		month: "Ой",
		months: "Ой",
		months4: "Ой",
		week: "Ҳафта",
		yesterday: "Кеча",
		day: "Кун",
		hour: "Соат",
		status: "Ҳолат",
		approval: "тасдиқловда",
		cancel: "бекор қилинган",
		btnApply: "Қўллаш",
		btnReset: "Барчасини аслига қайтариш",
		replenishment: "Тўлдириш",
		write: "Ечиш",
		payOrder: "Тўлов топшириқномаси рақами",
		receipt: "Квитанция",
		getReceipt: "Кўчирма олиш",
		repeat: "Такрорлаш",
		templates: "Шаблонларга",
		addTemplates: "Шаблонни қўшиш",
		nameCompany: "Корхона номи",
		paymentStatuses: {
			text1: "Аниқланмаган",
			text2: "Киритилган",
			text3: "Тасдиқланган",
			text4: "Ўтказилди",
			text5: "Ўчирилди",
			text6: "Рад этилган",
			text7: "Рад этилган",
			text8: "Кечиктирилган",
			text9: "Ҳисоб-китоб марказига юборилган",
			text10: "Бош офисга юборилган",
			text11: "Банк жараёни давом этмоқда",
			text12: "Имзо нотўғри",
			text13: "Таҳрирлашга юборилган",
			text14: "Банкка жўнатилмоқда",
			DELETED_BY_ACCOUNTANT: "Бекор қилинди",
			ON_ACCOUNTANT_LIST: "Имзолашда",
			ON_PROCESSING_LIST: "В ожидании",
			BANK_TREATMENT: "Отправлен в Банк",
			CANCELLED_BY_ACCOUNTANT: 'Бухгалтер томонидан ўчирилди',
			CANCELLED_BY_DIRECTOR: 'Рахбар томонидан ўчирилди',
			partiallyApproved: 'Қисман ўтказилган',
			unsent: 'Юборилмаган',
			DRAFT: 'Қоралама',
			UNDEFINED: 'Аниқланмаган',
			REJECTED_TCR: 'Ҳисоб-китоб марказ томонидан рад этилган',
		},
		client: "мижоз",
		debitAccount: "Тўловчининг дебет ҳисобварағи",
		amount: "Сумма",
		recipientCreditAccount: "Олувчининг кредит ҳисобварағи",
		amountWords: "Сумма сўз билан",
		bankCode: "Банк коди",
		recipientBankCode: "Олувчи банк коди",
		done: "Баж.",
		nameDoc: "Ҳужжат номи",
		respondingClerk: "Ижрочи",
		namePayers: "Тўловчи номи"
	},
	moduleCredit: {
		header: "Модулли кредит",
		title: "Ҳар қандай мақсадларга тез ва осон кредит олинг",
		btn: "Ариза қилиш",
		titleCondition: "Кредит шартлари",
		creditSize: "Кредит миқдори",
		rate: "Йиллик ставка",
		creditPeriod: "Кредит муддати",
		termReceipt: "Кредит олиш муддати",
		security: "Таъминот",
		text: "Маблағлар мижознинг ҳисоб рақамига йўналтирилади",
		checkboxText1: "Шарт ва шартларга розиман",
		checkboxText2: "Оммавий оферта",
		desiredCredit: "Керакли кредит лимити",
		confirmCredit: "Кредит шартларини тасдиқланг",
		btnClose: "Тасдиқламайман",
		btnGood: "Тасдиқлайман",
		creditApproved: {
			text: "Сизга қуйидаги шартлардаги кредит маъқулланди:",
			approvedMount: "Маъқулланган сумма:",
			duration: "Муддати:",
			interestRate: "Фоиз ставкаси:",
			confirmText: "Розилик билдириш ва давом эттириш учун, Сиз {0} гача қарор кабул қилишингиз керак",
			btnDeny: "Рад этиш",
			btnConfirm: "Тасдиқлаш"
		},
		unfortunately: {
			text: "Афсуски, модулли кредит хизматидан фойдалана олмайсиз.",
			otherText: "Модулли кредит олиш учун «InFinBank» АТБда бирламчи ҳисобварақ очиш талаб этилади",
			btn: "Бош саҳифага",
			notScoring: "Афсуски, скоринг текширувидан ўтмадингиз, шу сабабли модулли кредит хизматидан фойдаланиш имконсиз.",
			notScoringInfo: "Белгиланган тартибда кредитни олиш учун исталган «InFinBank» АТБ филиалигга мурожаат қилишингиз мумкин."
		},
		inProgress: {
			text: "Сизнинг модулли кредит олиш учун берган аризангиз қайта ишланмоқда Жавобни кутинг, тез орада аризангиз кўриб чиқилади, жавобни иловадаги билдиришнома орқали оласиз."
		},
		settings: {
			loanAmount: "от 25 млн. до 1 млрд.",
			annualRate: "22,99%",
			creditTerm: "90 кун",
			loanTerm: "от 1 до 2 кунгача",
			security: "Талаб этилмайди"
		},
		days: "{0} кун",
		enrollment: "Ўтказиш",
		status: {
			PENDING: "Сизнинг модулли кредит олиш учун берган аризангиз кўриб чиқилмоқда. Жавобни кутинг, у тез орада кўриб чиқилади ва жавоб иловангизга билдиришнома шаклида юборилади.",
			UNAVAILABLE: [
				"Aфсуски, Сизга Модулли кредит хизмати тақдим этилмайди.",
				"Модулли кредит олиш учун Сиз “InfinBANK” АТБʼда бирламчи ҳисобварақ очишингиз керак."
			],
			REJECTED: [
				"Aфсуски, Сиз балл текширувидан ўта олмадингиз, шунинг учун Сизга Модулли кредит хизмати тақдим этилмайди. {0} кундан кейн янги ариза топширишингиз мумкин.",
				"Сиз кредит олиш учун “InfinBANK” AТБʼнинг исталган филиалига белгиланган тартибда мурожаат қилишингиз мумкин."
			],
			TO_SUPPORT: "Аризангизни қайта ишлашда хатолик юз берди.<br>Қуйидаги телефон рақами бўйича алоқа марказига мурожаат қилишингизни сўраймиз: +998 (71) 202-50-80",
			END_TERM_SLA: "Модулли кредит олиш учун берган аризангизнинг муддати тугади",
			CANCELLED: "Сиз модулли кредит олишни рад этдингиз.",
			K2_APPROVED_RESULT: "2-картотеканинг ҳолати қайта текширилганда, Сизда ҳеч қандай қарздорлик топилмади ва Сизнинг аризангиз ҳисоб-китоб рақамингизга пул маблағларини киритиш учун юборилди. Илтимос кутиб туринг.",
			WAITING_FOR_K2_CHECK: "Биз 2-картотека бўйича қарздорликлар мавжудлигини текширяпмиз. Жавобни кутинг.",
			WAITING_FOR_LIMIT: "Сизнинг аризангиз ҳисоб-китоб рақамингизга пул маблағларини ўзтказиш учун юборилди. Илтимос кутиб туринг.",
			COMPLETED: "Сизнинг маблағларингиз ҳисоб-китоб рақамингизга муваффақиятли ўтказилди",
			WAITING_FOR_K2: [
				"2-картотека бўйича қарздорликлар ҳолатини текшириш учун К2 ни қайта текшириш тугмасини босинг",
				"2-картотекани қайта текшириш"
			],
			K2_DETECTED: [
				"Жорий санага кўра, Сизда 2-картотекага мувофиқ {0} сўм миқдорида қарздорлик бор.",
				"Тасдиқлаш тугмачасини босганингизда кредит маблағлари Сизнинг ҳисобварағингизга ўтказилади.",
				"Бекор қилиш тугмачасини босганингизда, банк кейинчалик кредит бериш учун картотеканинг тўлиқ сўндирилишини кутади.",
				"Сиз {0} гача қарор кабул қилишингиз керак."
			]
		}
	},
	notification: {
		header: "Хабарнома!",
		news: "Янгиликлар ",
		history: "Киришлар тарихи",
		btnDetails: "Батафсил",
		operation: 'Амалиётлар',
		newsAndOffers: 'Янгиликлар ва таклифлар'
	},
	publicOffer: {
		header: "Оммавий оферта",
		text: "Мазкур оферта бир томондан хориж капитали иштирокидаги «Invest Finance Bank» акциядорлик тижорат банки (кейинги ўринларда – Банк), бошқа томондан масофавий банк хизмати тизими (МБХТ) орқали юридик шахс ёки якка тартибдаги тадбиркор (кейинги ўринларда – Қарз Пул олувчи), яъни модулли кредит Пул олувчиси (бизнес овердрафт) (кейинги ўринларда кредит) ўртасида шартнома тузиш мақсадида ишлаб чиқилган.",
		titleAkb: '"InfinBANK" АТБ оммавий офертаси',
		instruction: 'Фойдаланувчи Қўлланмаси'
	},
	saleCurrency: {
		header: "Валюта сотиш",
		selectCur: "Валютани танланг",
		senderNumber: "Жўнатувчининг хисоб рақами",
		requestAmount: "Ариза суммаси",
		minRate: "Минимал курс",
		btbSend: "Юбориш"
	},
	setting: {
		title: "Комания номи",
		main: "Асосий",
		security: "Хавфсизлик",
		other: "Бошқа",
		lang: "Илова тили",
		save: "Сақлаш",
		offer: "Оферта",
		header: "Хавфсизликни созлаш",
		change: "Паролни ўзгартириш",
		current: "Жорий парол",
		new: "Янги парол",
		confirmNew: "Янги паролни тасдиқланг",
		changePasswordGoToBranch: "Сиз паролни 10 мартадан кўпроқ нотўғри киритдингиз. Паролни ўзгартириш учун Сиздан банк филиалига шахсингизни тасдиқловчи хужжат билан мурожаат қилишингизни сўраймиз",
		passwordIsntEqual: "Пароллар мос келмади, қайтадан уриниб кўринг",
		incorrectPassword: "Паролингиз нотўғри",
		incorrectPasswordValidate: "Парол 8 та лотин ҳарфидан иборат бўлиши, рақамлардан, камида 1 та бош ҳарфдан, камида 1 та кичик ҳарфдан иборат бўлиши керак",
		password: {
			title: "Парол кўйидагилардан иборат бўлиш керак:",
			min: "белгиларнинг умумий сони - 8",
			number: "рақамлар мавжудлиги",
			letter: "лотин алифбосидаги ҳарфларнинг мавжудлиги",
			minUpperLetter: "камида 1 та катта ҳарф бўлиш лозим",
			minLowerLetter: "камида 1 та кичик ҳарф бўлиш лозим",
			other: "Эҳтиёт бўлинг! Паролингизни ҳеч кимга берманг."
		},
		activeSession: {
			title: "Фаол сессиялар",
			current: "Жорий сессия",
			completeSessions: "Бошқа сессияларни тугатиш",
			online: "Тармоқда",
			textChange: "Сессияларни тугатиш учун «Таҳрирлаш» юқори тугмани босинг",
			complete: "Бажарилди"
		}
	},
	services: {
		url2: "Картотекани кўриш",
		title1: "Кредитлар",
		title2: "Депозитлар"
	},
	support: {
		header: "Ёрдам",
		title: "Ассалому алейкум, мен сизга қандай ёрдам бера оламан?",
		telegram: "Telegram bot орқали савол бериш",
		openTelegram: "Иловани очинг",
		phone: "Қўнғироқ қилиш",
		social: "Ижтимоий тармоқлар"
	},
	draft: {
		header: "Қоралама",
		changeStatus: "Ҳолатни ўзгартириш:",
		edit: "Таҳрирлаш",
		paymentRecipient: "Тўловни Пул олувчи",
		recipientBy: "Корхона номи",
		mfo: "Филиалга тегишли МФО",
		title1: "Сўм",
		title2: "Валюта",
		payment: "тўлов"
	},
	approval: {
		idDoc: "ID Ҳужжат",
		paymentCommission: "Комиссиялар",
		selectPayments: "Имзолаш учун тўловларни танланг",
		signAll: "Хаммасини тасдиқлаш",
		sign: "Имзога",
		sign2: "Имзолаш"
	},
	emptyStatuses: {
		header: "Рўйхат бўш",
		text: "Сизнинг сўровингиз бўйича маълумот йўк",
		emptyTransactions: 'Кўрсатилган даврда амалиётлар йўқ'
	},
	role: {
		employee: "Ходим",
		accountant: "Бухгалтер",
		director: "Директор"
	},
	roleInfo: {
		employee: "Ходим тўлов ҳужжатларини Банкка ижро учун юбориш имкониятисиз тўлов ва бошқа ҳужжатларни кўриб чиқиш ва киритиш ҳуқуқига эга.",
		accountant: "Бухгалтер тўлов ҳужжатларини Банкка ижро учун юбориш имкониятисиз тўлов ҳужжатлари ва бошқа ҳужжатларни киритиш, кўриб чиқиш ва имзолаш учун директорга юбориш, шунингдек, турли ҳисоботларни олиш ҳуқуқига эга.",
		director: "Директор МБХ га тўлиқ кириш, шу жумладан тўлов ҳужжатлари ва бошқа ҳужжатларни кўриб чиқиш, киритиш ва Банкка юбориш ҳуқуқига эга."
	},
	weekDays: {
		1: "душ",
		2: "сеш",
		3: "чор",
		4: "пай",
		5: "жум",
		6: "шан",
		7: "якш"
	},
	choose: "Танлаш",
	common: {
		attention: "Диққат"
	},
	number: [
		["бир", "бир", "нол"],
		["икки", "иккита"],
		["уч"],
		["тўрт"],
		["беш"],
		["олти"],
		["етти"],
		["саккиз"],
		["тўққиз"],
		["ўн"],
		["ўн бир"],
		["ўн икки"],
		["ўн уч"],
		["ўн турт"],
		["ўн беш"],
		["ўн олти"],
		["ўн етти"],
		["ўн саккиз"],
		["ўн тўққиз"],
		["йигирма"],
		["ўттиз"],
		["қирқ"],
		["эллик"],
		["олтмиш"],
		["етмиш"],
		["саксон"],
		["тўқсон"],
		["бир юз"],
		["икки юз"],
		["уч юз"],
		["тўрт юз"],
		["беш юз"],
		["олти юз"],
		["етти юз"],
		["саккиз юз"],
		["тўққиз юз"],
		["минг"],
		["минг"],
		["минг"],
		["миллион"],
		["миллион"],
		["миллион"],
		["миллиард"],
		["миллиард"],
		["миллиард"],
		["триллион"],
		["триллион"],
		["триллион"]
	],
	currency: {
		cent: {
			RUB: ["тийин", "тийин", "тийин"],
			USD: ["цент", "цент", "цент"],
			EUR: ["евроцент", "евроцент", "евроцент"],
			UZS: ["тийин", "тийин", "тийин"]
		},
		self: {
			RUB: ["рубл", "рубл", "рубл"],
			USD: ["АҚШ доллари", "АҚШ доллари", "АҚШ доллари"],
			EUR: ["евро", "евро", "евро"],
			UZS: ["сўм", "сўм", "сўм", 'сўмдан']
		}
	},
	month: [
		["январ"],
		["феврал"],
		["март"],
		["апрел"],
		["май"],
		["июн"],
		["июл"],
		["август"],
		["сентябр"],
		["октябр"],
		["ноябр"],
		["декабр"]
	],
	date: {
		yearShort: "г."
	},
	validate: {
		numberCard: "Сиз фақат компаниянгизнинг карталарини тўлдиришингиз мумкин. Олувчининг ҳисоб рақамини текширинг"
	},
	emptyBlock: {
		accounts: {
			title: "Сизда ҳеч қандай ҳисобварақ йўқ",
			text: "Ҳисобварақни танлаш учун аввал уни расмийлаштириш учун ариза бериш зарур"
		},
		cards: {
			title: "Сизда корпоратив карталар мавжуд эмас",
			text: "Карталарни танлаш учун эмиссияга ариза топширишингиз  керак"
		},
		companyAccounts: {
			title: "Маҳсулотлардан бирини танланг",
			text: "Бу ерда картангиз, ҳисобварағингиз, кредитингиз ёки депозитингиз маълумотлар мавжуд бўлиб, маълумотни кўриш учун маҳсулотлардан бирини танланг"
		},
		later: {
			title: "Кейинроқ уриниб кўринг",
			text: "Амалиёт кунини ёпиш жараёни давом этмоқда."
		},
		contragent: {
			title: "Ҳамкорларнинг рўйхати бўш",
			text: "Қўшимча матн"
		},
		contragent2: {
			title: "Ҳамкорни қўшинг",
			text: "Ҳамкорни қўшгандан сўнг, уни чапдаги рўйхатдан танланг, барча батафсил маълумотлар бу ерда кўрсатилади."
		},
		employees: {
			title: "Ходимлардан бирини танланг",
			text: "Бу ерда сизнинг ходимларингиз ҳақидаги маълумотлар мавжуд бўлиб, маълумотни кўриш учун ходимлардан бирини танланг"
		}
	},
	form: {
		fill: "Илтимос, ушбу майдонни тўлдиринг",
		payrollPurpose: '"Тўлов мақсади" майдонига камида {0} та белги киритинг, сиз {1} та белгини киритдингиз'
	},
	modalTemplate: {
		title: "Номини киритинг",
		deleteTitle: "Андазани ўчириб ташлаш",
		deleteText: "Шаблонни ўчириб ташламоқчилигингизга ишончингиз комилмими"
	},
	statuses: {
		titleDeleteDraft: "Ўчириш учун қоралама бандини танланг",
		textSelected: "Танланганларни ўчириш"
	},
	eimzo: {
		titleSelected: "Калитни танланг",
		errorCAPIWS: "E-IMZO билан уланишда хатолик рўй берди. Эҳтимол сизда E-IMZO модули ёки E-IMZO браузери ўрнатилмаган бўлиши мумкин.",
		errorBrowserWS: "Браузер WebSocket технологиясини қўллаб-қувватламайди. Браузернинг сўнгги версиясини ўрнатинг.",
		errorUpdateApp: "ДИҚҚAТ !!! E-IMZO иловасининг ёки E-IMZO браузерининг янги версиясини ўрнатинг.",
		errorDownloadEimzo: "E-IMZO дастурини юклаб олинг",
		errorDownloaded: "Юкланмоқда",
		errorWrongPassword: "Парол нотўғри"
	},
	crk: {
		titleModal: 'SM ERI',
		titleSelected: 'Калитни танланг',
		deadline: 'Муддати',
		expired: 'тугади',
		errorWrongPassword: 'Парол нотуғри',
		errorCrk: 'СМ ЭРИ билан алоқа ўрнатиб бўлмади',
		errorKeyCrk: 'Калит топилмади!',
		errorApp: 'СМ ЭРИ модули уланмади. Модулни ўрнатинг',
		errorConfirmCrk: 'СМ ЭРИга киришда хатолик юз берди',
		errorDefault: 'ЭРИ текширилаётганда хатолик юз берди. Амалиётни кейинроқ такрорланг ёки Банкка мурожаат қилинг.',
		errorKeyNotFound: 'ЭРИ калити топилмади.  USB калитини компютерга уланишини текширинг.',
		downloadModule: 'Модулни юклаш'
	},
	forex: {
		countryName: 'Мамлакат номи',
		title: 'Валюта амалиётлари',
		buyCurrency: 'Валютани харид қилиш',
		sellCurrency: 'Валюта сотиш',
		create: 'Ариза яратиш',
		appWillLost: 'Ариза бўйича маълумотлар йўқолади',
		appAndFilesWillLost: 'Ариза бўйича маълумотлар ва бириктирилшган файллар йуқолади',
		replaceFilePrevent: 'Аризага фақат битта файл бириктирилиши мумкин',
		replace: 'Ўзгартириш',
		uz: 'O\'zbekistan',
		day: 'Ариза санаси',
		buy: 'Харид',
		sell: 'Сотув',
		sendToAccountant: 'Сизнинг {1}й.даги {0} миқдоридаги аризангиз бухгалтерга мувоффақиятли юборилди',
		sendToDirector: 'Сизнинг {1}й.даги {0} миқдоридаги аризангиз рахбарга мувоффақиятли юборилди',
		sendToBank: 'Сизнинг {1}й.даги {0} миқдоридаги аризангиз банкка мувоффақиятли юборилди',
		saveUpdates: 'Ўзгаришларни сақлаш',
		confirmDeleteDraft: 'Сиз қораламани ўчирмоқчимисиз?',
		enterTemplateName: 'Шаблон номини ёзинг',
		existTemplateName: 'Кўрсатилган ном билан шаблон аллақачон мавжуд',
		templateName: 'Шаблон номи',
		deleteTemplate: 'Шаблонни ўчириш',
		confirmDeleteTemplate: 'Шаблоннни ўчирмоқчимисиз?',
		applicationNumber: '№ ариза',
		enterApplicationNumber: 'Ариза рақамини киритинг',
		status: {
			ON_ACCOUNTANT_LIST: 'Тасдиқлаш учун бухгалтерда',
			ON_DIRECTOR_LIST: 'Рахбарда имзолашда',
			DELETED_BY_ACCOUNTANT: 'Бухгалтер томонидан ўчирилди',
			DELETED_BY_DIRECTOR: 'Рахбар томонидан ўчирилди',
			ON_PROCESSING_LIST: 'В ожидании',
			INTRODUCED: 'Киритилган',
			BANK_REVIEW: 'Банкда кўриб чиқилмоқда',
			CONFIRMED: 'Тасдиқланган',
			CONDUCTED_GO: 'Бош Офисда ўтказилди',
			CONDUCTED_BRANCH: 'Филиалда ўтказилди',
			REJECTED: 'Рад қилинган',
			DELETED: 'Ўчирилди',
			CREATED: 'Яратилди',
			BANK_TREATMENT: 'Банкка юборилди',
		},
		downloadPdf: 'ПДФ форматида юклаб олиш',
		toTemplate: 'Шаблонларга',
		approvalDelete: {
			deleteOne: 'Сиз аризани ўчирмоқчимисиз?',
			deleteFour: 'Сиз {0} та аризани ўчирмоқчимисиз?',
			deleteFive: 'Сиз {0} та аризани ўчирмоқчимисиз?',
		},
		confirmAndSend: 'Тасдиқлаш ва юбориш',
		payments: 'Тўловлар',
		applications: 'Ариза',
		purpose_CODE_011: '<ol><li>Тасисчиларнинг фойдани тақсимлаш тўғрисидаги қарори;</li><li>Аудиротлик ташкилоти ёки солиқ органининг хулосаси;</li><li>Маблағларни конвертация қилиш учун хисоблаш.</li></ol>',
		purpose_CODE_012: '<ol><li>Хизмат сафари тўғрисидаги буюруқ нусхаси;</li><li>Чет эл валютасида суммани хисоблаш;</li><li>Вазирлар махкамасининг қарори (Мавжуд булса).</li></ol>',
		purpose_CODE_014: '<ol><li>Хисоб-китоб палатсининг асл нусхаси;</li><li>Брокер(инвестиция воситачиси) ва норезидент - юридик шахс ўртасида брокерлик хизматларини кўрсатиш тўғрисида тузилган шартноманинг тусхаси</li></ol>',
		accountVerifyingError: {
			WRONG_DATE: 'Календар санаси банк санаси билан тўғри келмаганлиги сабабли хозирги вақтда аризани банкка юбориб бўлмайди.',
			RATE_CHANGED: 'Диққат! Валюта курси ўзгарди',
			FUNDS_LACK: 'Ушбу миқдорда амалиётни амалга ошириш учун маблаҳ {0}',
			CONTRACT_NOT_ACTIVE: 'Шартнома амал қилиш муддати тугаган. Ўзгартириш киритишингизни сўраймиз',
			FUNDS_LACK_SELL: '{2} {1} миқдорида амалиётни амалга ошириш учун хисобдан чиқариш хисобварағида {0} {1} маблағ етмаяпти.',
		},
		rateChanged: 'Бошланғич курс: {0} UZS<br>Жорий курс: {1} UZS<br>Миллий валюта эквивалентида: {2} UZS',
		openReceiverAccount: 'Амалиётни амалга ошириш учун сиз конвертация махсус хисоб рақамини очишингиз керак',
		refillAccountBySendingPayment: 'Сизнинг заявкангизни қоплаш учун {0} UZS миқдорида маблағ етмаяпти. Тўловни яратиб ва банкка жунатмоқчимисиз?',
		paymentOrderDetails: '{1}й.даги {0}-сонли шартнома бўйича конвертация қилиш учун маблағни блоклаш',
		paymentOrderOnlyDetails: 'Шартнома бўйича конвертация қилиш учун маблағни блоклаш',
		toFullCompletion: 'Тўлиқ бажарилгунга қадар',
		course: 'Валюта курси',
		courseAvailable: 'Курс жорий кун учун хақиқий',
		uzsEquivalent: 'Миллий валютадаги эквивалент ',
		purpose: 'Сотиб олиш мақсади ',
		idnNumber: 'Ташқи савдо шартномаси рақами',
		idnDate: 'Шартномаса санаси',
		idnCountry: 'Хорижий хамкор давлати',
		phone: 'Мижоз телефони',
		additional: 'Қушимча',
		serviceType: 'Хизмат тури',
		shortPurposeDesc: 'Мақсаднинг қисқача тавсифи ',
		account: 'Мижоз хисоб рақами',
		reservingAccount: 'Захира учун хисоб рақам',
		loanAccount: 'Кредитни қайтариш учун хисоб рақам',
		receiverAccount: 'Валютадаги махсус хисоб рақам',
		contractEndDate: 'Шартноманинг амал қилиш муддати',
		partnerName: 'Хорижий хамкор номи',
		contractAmount: 'Шартнома суммаси',
		purposeItems: {
			CODE_001: 'Ускуналар, аксессуарлар ва эхтиёт қисмлар',
			CODE_002: 'Хомашё ва материаллар',
			CODE_003: 'Хизматлар',
			CODE_004: 'Кредитлар: Хукумат томонидан кафолатланган',
			CODE_005: 'Кредитлар: Хукумат томонидан кафолатланмаган',
			CODE_006: 'Хизмат курсатувчи банкдан олинган кредитни тўлаш учун',
			CODE_007: 'Лизинг тўловлари',
			CODE_008: 'Дорилар, дори воситалари ва тиббий асбоблар',
			CODE_009: 'Енгил автомобиллар',
			CODE_010: 'Бошқа истемол товарлари ',
			CODE_011: 'Хорижий инвесторларинг даромадларини репотрация қилиш учун',
			CODE_012: 'Хизмат сафари харажатлари',
			CODE_013: 'Бошқа мақсадлар учун',
			CODE_014: 'Товар-хом ашё биржаларининг очиқ электрон аукционларида махсулот сотишдан тушган маблағларни ўтказиш',
		},
		transactionCode: 'Транзакция коди',
		fundsSource: 'Маблағлар манбаи',
		currencyAccount: 'Чэт эл валютасидаги хисоб рақам',
		shortDesc: 'Қисқача тавсифи',
		buyTypeItems: {
			TRANSPORTATION: 'Транспорт хизматлари',
			CONSULTING: 'Консалтинг хизматлари',
			ADVERTISING: 'Реклама хизматлари',
			REPAIR: 'Таъмирлаш хизматлари',
			COMMUNICATION: 'Алоқа хизматлари',
			INSURANCE: 'Суғурта хизматлари',
			FINANCIAL: 'Молиявий хизматлари',
			ROYALTIES: 'Роялти',
			INFORMATION: 'Ахборот хизматлари',
			CONSTRUCTION: 'Қурулиш хизматлари',
			OTHER: 'Бошқалар',
		},
		buyForeignCurrency: 'Чет эл валютасини сотиб олиш',
		sellForeignCurrency: 'Чет эл валютасини сотиш',
		exchange: 'Қаттиқ валютани қаттиқ валютага алмаштириш',
		foundsSourceItems: {
			EXPORT_EARNINGS: 'Экспортдан тушган тушум',
			LOANS_RECEIVED_FROM_DOMESTIC_BANK: 'Махаллий банкдан олинган кредитлар',
			LOANS_FROM_ABROAD: 'Чет элдан олинган кредитлар',
			REVERSE_SALE_UNUSED_CURRENCY: 'Фойдаланилмаган валютани қайта сотиш',
			OTHER_REFERENCES: 'Башқа манбалар',
		},
		amountFrom: 'Миқдоридан',
		amountTo: 'Миқдоригача',
		fileUploadRequired: 'Файлни загрузка қилиш мажбурий',
	},
	modals: {
		anor: {
			modalConfirmTitle: "Ўтказма турини танланг",
			modalConfirmText: "Ҳозирги вақтда Марказий банкнинг ҳисоб-китоб маркази transfer сўровларини қабул қилмайди. Сиз АНОР орқали пул ўтказишингиз мумкин. Ўтказиш усулини танланг:",
			btnAnor: "АНОР орқали",
			btnCB: "Марказий Банк Ҳисоб-Китоб Маркази",
			btnLater: "Кейинроқ бажариш"
		}
	},
	sessionExpired: 'Сиз жуда узоқ вақт фаол бўлмадингиз. Хавфсизлик сабабли автоматик равишда чиқиш амалга оширилди. Давом этиш учун қайта тизимга киринг.',
	openAccount: {
		enterPhoneNumber: 'Введите номер телефона',
		customerName: 'Укажите как к Вам обращаться',
		getCode: 'Получить код',
		confirmOffer: 'Нажимая «{0}», Вы принимаете и соглашаетесь с условиями <a href="{1}" target="_blank" class="link-primary">оферты</a>',
		inn: 'ИНН юридического лица',
		pinfl: 'ПИНФЛ юридического лица',
		fillApplication: 'Заполните заявку на оформление счёта',
		isIndividualEntrepreneur: 'Сиз корхона ЯТТ хисобланадими?',
		isIndividualEntrepreneurDescription: 'ИП - индивидуальным предпринимателем',
		openSecondaryAccount: 'Вы открываете вторичный счёт',
		companyName: 'Ташкилот номи',
		registerDate: 'Рўйхатдан ўтилган санаси',
		registerEndDate: 'Рўйхатдан ўтиш санасининг тугаши',
		companyAddress: 'Ташкилот манзили',
		primaryAccountBank: 'Банк в котором открыт первичный счет',
		yourApplications: 'Сизнинг аризангиз',
		status: {
			OPEN: 'Банк томонидан қабул қилинди',
			DECLINED_BY_BANK: 'Банк томонидан рад этилди',
			DECLINED_BY_CUSTOMER: 'Мижоз рад қилди',
			ACCOUNT_OPENED: 'Счет открыт',
			DONE: 'Бажарилди',
		},
		warnTheClient: 'Ҳисоб рақам очиш учун аризангиз қабул қилинди. Ходимларимиз тез орада сиз билан боғланишади.',
		documentsNotProvided: 'Предоставлены не все необходимые документы',
		accountType: {
			PRIMARY_ACCOUNT: 'Первичный счет',
			SECONDARY_ACCOUNT: 'Вторичный счет'
		},
		aboutCompany: 'Компания хакида',
		toMainPage: 'На главную сайта',
		legalEntityLoadingHintList: [
			'Ищем Ваши ранее оставленные заявки...',
			'Ищем среди клиентов...',
			'Проверяем информацию в службе Единого окна...',
			'Ищем Ваши счета в других банках...',
			'Сверяем данные...',
			'Осталось совсем немного подождать...',
		],
		organizationName: 'Наименование организации',
		initiatorPhone: 'Номер телефона инициатора заявки',
		innOrPinfl: 'Сизнинг СТИР/ПИНФЛ',
		applicationNumber: 'Ариза рақами',
		applicationDate: 'Дата заявки',
		selectedTariff: 'Танланган тариф',
		accountTypeTitle: 'Хисоб рақам тури',
		employeesCount: 'Internet-banking хизматига ега бўлган ходимлар сони',
		branchNumber: 'Филиал МФО си',
		assignedEmployee: 'Ходим тайинланди',
		meetingAddress: 'Учрашув манзили',
		bankEmployeePhone: 'Банк ходимининг telefon рақами',
		meetingDate: 'Учрашув санаси ва вақти',
		applyApplication: 'Подать заявку',
		application: 'Заявка на открытие счета',
		enterSmsCode: 'Введите код из СМС',
		codeSent: 'Код выслан на номер {0}',
		incorrectInn: 'Юридическое лицо с таким ИНН не существует. Проверьте корректность введенного ИНН',
		changePhone: 'Изменить телефон',
		getNewCode: 'Получить новый код можно через {0}:{1} сек.',
		end: 'Заполнение заявки завершено'
	},
	paymentRequirements: {
		incoming: 'Кирувчи тўлов талабномалари',
		outgoing: 'Чиқувчи тўлов талабномалари',
		familiarize: 'Танишиб чиқиш',
		offer: 'Ҳозирда {1} га тақдим этилган {0} дона миқдоридаги тўлов талабномалари билан танишганимни тасдиқлайман. <br><br>Тақдим этилган тўлов талабномалари рўйхати билан танишганлик ҳолатини тасдиқлаганимдан сўнг, ҳозирги вақтда {1} га тақдим этилган барча тўлов талабномалари 1-чи картотекага жойлаштирилишини тушунаман.<br><br>Талабномалар 1-картотекага жойлаштирилгандан сўнг, агар мен 5 иш куни ичида ушбу талабномаларни тўлаш ёки тўлашдан бош тортиш тўғрисида қарор қабул қилмасам, у ҳолда улар автоматик равишда амалга оширилиши ёки 2-картотекага жойлаштирилишини тушунаман (талабномани тўлаш учун ҳисоб рақамда маблағ бўлмаган тақдирда).',
		requestsProcessed: 'Тўлов талабномалари муваффақиятли бажарилди',
		requestsProcessedDetails: '{0} тўлов талабномаларидан {1} талабномалар муваффақиятли кўриб чиқилди ва 1-чи картотекага жойлаштирилди. Талабномани тўлаш ёки тўлашдан бош тортиш учун Сиз 1-чи картотека маълумотларини кўриш саҳифасига ўтишингиз мумкин.',
		requestsProcessedHint: 'Картотекага ўтганингизда, жорий амалиётингиз қораламаларда сақланиб туради.',
		sign: 'Таништириш',
		requests: 'Тўлов талабномалари',
		request: 'Тўлов талабнома',
		goToCardIndex: '{0}-чи картотекага ўтиш',
		incomingShort: 'Кирувчи',
		outgoingShort: 'Чиқувчи',
		docDate: 'Ҳужжат санаси',
		debtType: 'Қарздорлик тури',
		destCardIndexCode: 'Картотеканинг мақсади коди',
		destCode: 'Тўлов мақсади коди',
		toCompany: 'Талабнома тақдим этган ташкилот',
		fromCompany: 'Топшириқнома берилган ташкилот',
		pinfl: 'ПИНФЛ',
		unprocessed: 'Ишлов берилмаган',
		processed: 'Ишлов берилган',
		dueDate: 'Қарор қабул қилиш керак',
		daysLeft: {
			one: '{0} кун қолди',
			fromTwoToFour: '{0} кун қолди',
			fromFive: '{0} кун қолди',
		},
		denie: 'Рад этиш',
		pay: 'Тўлаш',
		denieTitle: 'Рад этиш',
		rejectionReason: 'rejectionReason',
		create: 'Тўлов топшириқномасини яратиш',
		recall: 'Қайтариб олиш',
		createShort: 'Яратиш',
		recallQuestion: 'Тўлов топшириқномаси қайтарилсинми?',
		fundRecipient: 'Маблағ олувчи',
		fundSender: 'Маблағ юборувчи',
		withAcceptance: 'Акцепт билан',
		withoutAcceptance: 'Акцептсиз',
	},
	attachments: 'Қўшимчалар',
	attachDocument: 'Ҳужжатни бириктиринг',
	minLength: 'Белгиларнинг энг кам миқдори {0}',
	uploadFiles: 'Файлларни юклаб олиш',
	acceptedFileFormats: 'Қуйидаги форматларда ишлайди: {0}',
	paymentsAndApplications: 'To\'lovlar va ilovalar',
	minAmount: 'Минимал сумма {0}',
	hasUpdate: 'Янгиланиш чиқди',
	update: 'Янгилаш',
	minAmountOperation: 'Амалиёт суммаси {0} кам бўлмаслиги керак',
	innOrPinflInvalid: 'Агар олувчи юридик шахс бўлса, 9 та рақамни, агар олувчи ЯТТ бўлса, 14 та рақамни киритинг',
	incorrectAccount: 'Ҳисоб рақам рақами нотўғри киритилган',
	beforeInputMFO: 'Ҳисоб рақамни текшириб бўлмади. МФО ни киритинг',
	incorrectAccountOrMfo: 'Ҳисоб рақам ёки МФО рақами нотўғри киритилган',
	reference: {
		branch: 'МФО рақами ва номи бўйича қидириш',
		code: 'Код',
		codeDescription: 'Картотекага берилган коднинг тавсифи',
		debtDescription: 'Қарздорлик турининг тавсифи',
		debt: 'Қарздорлик турини излаш',
		codeCardIndex: 'Картотеканинг мақсадли кодини қидириш',
		purposeCode: 'Тўлов мақсади кодини топиш',
		purposeDescription: 'Тўлов мақсади кодининг тавсифи',
	},
	needBankAccount: 'Чиқувчи тўлов топшириқномасини расмийлаштириш учун асосий ҳисоб рақам InFinBank. -да очилган бўлиши керак',
	startSearch: 'Излашни бошланг',
	confirmActionWithSms: 'СМС код ёрдамида амални тасдиқланг',
	alert: {
		browserError: 'Кечирасиз, браузерингиз ишламаяпти. Илова билан боғлиқ муаммолар бўлиши мумкин.',
		supportBrowser: 'Қўллаб-қувватланадиган браузерлар',
		titleSupportBrowser: 'Қўллаб-кувватловчи браузерлар',
		versionOld: '{0} йоки ундан кейинги версия'
	},
	revisionError: {
		title: 'Ишни кам-кўстини тўлдириб, охирига етказиш учун қайтариш сабаби',
		allAmount: 'Қарздорликнинг умумий миқдори',
		deleteDocumnet: 'Хужжатни ўчириш',
		deleteQuestion: 'Ўчириб ташламоқчимисиз?'
	}
};
